import { css } from '@emotion/core';
import { applyFont, rgba, tokens } from '@domain-group/fe-brary';
import { truncateLines } from '@domain-group/fe-co-allhomes-design-system';
import { isBrightColour } from '../../utils/is-bright-colour';
var colors = tokens.colors,
  typography = tokens.typography;
var CARD_GRADIENT_START_COLOUR = rgba(42, 42, 41, 0.48);
var CARD_GRADIENT_END_COLOUR = rgba(66, 67, 66, 0.0);
var IMAGE_COUNT_PILL_BG_COLOUR = rgba(11, 32, 71, 0.8);
var borderRadius = '10px';
export var listingCard = _ref5 => {
  var appearance = _ref5.appearance,
    noBorderRadius = _ref5.noBorderRadius,
    noBorder = _ref5.noBorder;
  return /*#__PURE__*/css("display:flex;position:relative;flex-direction:", appearance === 'vertical' ? 'column' : 'row', ";align-items:flex-start;border-radius:", noBorderRadius ? 0 : borderRadius, ";border:", noBorder ? 'none' : "1px solid ".concat(colors.neutral.trim.default), ";background:", colors.neutral.surface.default, ";");
};
export var cardLink = /*#__PURE__*/css("text-decoration:none;color:", colors.neutral.heavy.default, ";&::before{position:absolute;top:0;right:0;left:0;bottom:0;content:'';}");
export var hover = {
  name: "10jr14j",
  styles: ":hover{cursor:pointer;}"
};
var _ref = {
  name: "ynw3tr",
  styles: "width:381px;"
};
export var imageContainer = _ref6 => {
  var appearance = _ref6.appearance,
    noBorderRadius = _ref6.noBorderRadius;
  return /*#__PURE__*/css("overflow:hidden;position:relative;align-self:stretch;", !noBorderRadius && (appearance === 'vertical' ? /*#__PURE__*/css("border-top-right-radius:", borderRadius, ";border-top-left-radius:", borderRadius, ";") : /*#__PURE__*/css("border-top-left-radius:", borderRadius, ";border-bottom-left-radius:", borderRadius, ";")), " ", appearance !== 'vertical' && _ref);
};
var _ref2 = {
  name: "1phd9a0",
  styles: "object-fit:cover;"
};
var _ref3 = {
  name: "14yuxbt",
  styles: "height:200px;width:100%;"
};
var _ref4 = {
  name: "1y6yqzs",
  styles: "height:100%;width:381px;"
};
export var image = _ref7 => {
  var appearance = _ref7.appearance,
    hasImage = _ref7.hasImage;
  return /*#__PURE__*/css("display:block;", hasImage ? _ref2 : /*#__PURE__*/css("background:", colors.neutral.subdued.default, ";"), " ", appearance === 'vertical' ? _ref3 : _ref4);
};
export var top = /*#__PURE__*/css("display:flex;position:absolute;justify-content:space-between;top:0;bottom:0;left:0;right:0;height:56px;background:linear-gradient( 180deg,", CARD_GRADIENT_START_COLOUR, " 0%,", CARD_GRADIENT_END_COLOUR, " 100% );");
export var badges = {
  name: "26c8cx",
  styles: "display:flex;gap:4px;padding:8px;"
};
export var badge = _ref8 => {
  var _ref8$bgColour = _ref8.bgColour,
    bgColour = _ref8$bgColour === void 0 ? colors.neutral.surface.default : _ref8$bgColour;
  return /*#__PURE__*/css(truncateLines(1), " overflow:hidden;padding:4px 8px;align-items:center;gap:8px;height:28px;border-radius:100px;background:", bgColour, ";color:", colors.neutral.heavy.default, ";", applyFont(typography.miniBold));
};
export var galleryBadge = /*#__PURE__*/css("display:flex;gap:4px;margin:8px 8px 0 0;padding:4px 8px;height:28px;justify-content:center;align-items:center;align-self:stretch;border-radius:100px;background:", IMAGE_COUNT_PILL_BG_COLOUR, ";color:", colors.neutral.surface.default, ";", applyFont(typography.mini));
export var content = {
  name: "1ofqig9",
  styles: "display:flex;flex-direction:column;width:100%;"
};
export var defaultContent = {
  name: "1ldfq7",
  styles: "display:flex;flex-grow:1;align-items:flex-start;gap:10px;align-self:stretch;justify-content:space-between;padding:16px;"
};
export var details = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:flex-start;align-self:stretch;color:", colors.neutral.heavy.default, ";");
export var title = /*#__PURE__*/css(applyFont(typography.displaySmall), " ", truncateLines(1));
export var line12 = /*#__PURE__*/css(applyFont(typography.body), " ", truncateLines(2));
export var features = {
  name: "qxw5qd",
  styles: "display:flex;align-items:baseline;gap:8px;margin-top:4px;"
};
export var feature = {
  name: "q85vku",
  styles: "display:flex;align-items:baseline;gap:4px;"
};
export var featureIcon = {
  name: "19rsff",
  styles: "width:18px;height:18px;"
};
export var featureValue = /*#__PURE__*/css(truncateLines(1), " ", applyFont(typography.miniBold));
export var button = {
  name: "18xe2wc",
  styles: "display:flex;flex-direction:column;align-items:flex-end;gap:10px;width:24px;max-height:24px;max-width:24px;z-index:3;"
};
export var extraContent = {
  name: "hvwk7f",
  styles: "padding:0 16px 16px;"
};
export var agencyBranding = _ref9 => {
  var backgroundColour = _ref9.backgroundColour;
  return /*#__PURE__*/css("display:flex;align-items:center;justify-content:space-between;width:100%;height:44px;background-color:", backgroundColour, ";padding:4px 8px 4px 4px;border-bottom:1px solid ", colors.neutral.trim.default, ";");
};
export var agencyLogo = {
  name: "13jftbp",
  styles: "width:100%;height:100%;object-fit:contain;object-position:left;"
};
export var agentContainer = {
  name: "xqry2",
  styles: "display:flex;align-items:center;justify-content:flex-end;gap:10px;width:100%;max-width:216px;"
};
export var agentNames = backgroundColour => /*#__PURE__*/css("display:flex;flex-direction:column;", applyFont(typography.mini), " ", truncateLines(2), " color:", isBrightColour(backgroundColour) ? colors.neutral.heavy.default : colors.neutral.surface.default, ";");
export var avatarContainer = {
  name: "1x5vurj",
  styles: "display:flex;justify-content:center;position:relative;bottom:13px;"
};
export var avatar = /*#__PURE__*/css("width:48px;height:48px;min-width:48px;min-height:48px;border:1px solid ", colors.neutral.surface.default, ";");
export var nextInspection = /*#__PURE__*/css("display:inline-flex;align-items:center;background-color:", colors.accentTwo.subdued.default, ";padding:2px 8px;border-radius:4px;", applyFont(typography.miniBold));
export var calendarIcon = {
  name: "1lxvmmi",
  styles: "position:relative;margin-right:4px;"
};
export var mediaStats = {
  name: "1g20jmw",
  styles: "position:relative;align-items:flex-start;height:fit-content;margin:8px;padding-inline:4px;right:0;bottom:0;"
};
export var bottomRightComponent = {
  name: "1pije7c",
  styles: "position:absolute;right:8px;bottom:2px;"
};